import { Component } from '@angular/core';

@Component({
  selector: 'app-paiement-demande',
  templateUrl: './paiement-demande.component.html',
  styleUrl: './paiement-demande.component.scss'
})
export class PaiementDemandeComponent {

}
